import { AutoSuggestData } from "../pages/listing/interface/bizType";
import {
  setItemBySession,
  getItemBySession,
  itemType
} from "MMT-UI/storages/client/sessionStorage";
import { getCookie } from "./trainUtils";
import { getUserInfoPIIClient } from "pwa-mmt-ui-header/getPIIData/client";
import { FETCH_TRAVELLERS, UPDATE_USER_DETAIL } from "../constants/ActionTypes";
import {
  AGE_DEFAULT,
  BERTH_PREFERENCE_DEFAULT,
  BIZ_PROFILE,
  COUNTRY_PREFERENCE_DEFAULT,
  GENDER_DEFAULT,
  MMT_AUTH,
  MYBIZ_BLOCKED_LOB_ID,
  MY_BIZ_TRAVELERS,
  MY_BUSINESS_SUBSCRIPTION,
  RESERVATION_TYPE_DEFAULT,
  SENIOR_CITIZEN_CONCESSION_DEFAULT
} from "../constants/TrainConstants";
import { getGenderByCode } from "../constants/Genders";
import { getItem } from "MMT-UI/storages/client/localStorage";
import { generateId } from '../utils/trainUtils';
import { getApplicableFoodTypes, DEFAULT_FOOD_TYPE } from "../constants/Meals";

const RECENT_SEARCH_LENGTH = { MAX: 5, COLLEAGUE: 3 };
export const BOOKING_FOR = "myBizBf";

export const isBussinessUser = () =>
  getCookie(MY_BUSINESS_SUBSCRIPTION) === BIZ_PROFILE;

export const isUserLoggedIn = () => !!getCookie(MMT_AUTH);

export const formatEmployees = (
  empList: Array<Record<string, any>> = []
): AutoSuggestData => {
  const empApiData: AutoSuggestData = {
    isSuccess: false,
    isFailed: true,
    isCalling: false,
    empList: [],
    errorMsg: "Please enter valid email"
  };
  if (empList) {
    empApiData.isSuccess = empList.length > 0;
    empApiData.isFailed = empList.length === 0;
    empApiData.empList = empList.map(data => {
      return {
        desc: data?.businessEmailId,
        head: data?.name,
        id: data?.businessEmailId,
        value: data?.businessEmailId,
        mobile: data?.phoneNumber || "",
        gender: data?.gender || ""
      };
    });
  }

  return empApiData;
};

export const handleCssForMyBiz = async () => {
  const isB2b = isBussinessUser();
  const isLoggedIn = isUserLoggedIn();
  const userInfo = isLoggedIn ? await getUserInfoPIIClient() : {};
  const isTrainLobBlocked =
    userInfo?.blockLobs?.includes(MYBIZ_BLOCKED_LOB_ID);
  if (isB2b) {
    if (isTrainLobBlocked) {
      // Product Requirement to redirect to flights
      window.location.href = "https://www.makemytrip.com/flights";
      return;
    }
    document.body.classList.add("myBizContent");
  } else {
    document.body.classList.remove("myBizContent");
  }
};

export const getMyBizHeaders = async (pageType, requisitionId) => {
  const traceId = generateId();
  const isB2b = isBussinessUser();
  if (!isB2b) {
    return {};
  }
  const mmtAuth = getCookie(MMT_AUTH);
  const isLoggedIn = isUserLoggedIn();
  const { email = "", uuid = "" } = isLoggedIn
    ? await getUserInfoPIIClient()
    : {};
  const headers = {
    "mmt-auth": mmtAuth,
    travelleremailid: `[${email}]`,
    "mmt-uuid": uuid,
    "mmt-my-business-subscription": "b2b",
    "X-Trace-Id": traceId,
    ...pageType && { "page-type": pageType },
    ...requisitionId && { "requisition-id": requisitionId }
  };
  return headers;
};

export const getBookingForDataFromStorage = () => {
  let users = getItemBySession(
    BOOKING_FOR,
    { isPiiData: true, shouldParseJson: true },
    itemType.ES
  );
  if (Array.isArray(users)) {
    return users;
  }
  users = getItem(
    BOOKING_FOR,
    { isPiiData: true, shouldParseJson: true },
    itemType.ES
  );
  return users;
};

export const setBookingForDataInStorage = user => {
  const currentStorage: any = getBookingForDataFromStorage();
  let newStorageitem;
  if (!currentStorage) {
    newStorageitem = [user];
  } else if (currentStorage) {
    const usersNotAlreadyPresent = currentStorage.filter(
      lUser => lUser.email !== user.email || lUser.bf !== user.bf
    );
    if (
      usersNotAlreadyPresent &&
      usersNotAlreadyPresent.length < RECENT_SEARCH_LENGTH.MAX
    ) {
      newStorageitem = [user, ...usersNotAlreadyPresent];
    } else if (
      usersNotAlreadyPresent &&
      usersNotAlreadyPresent.length >= RECENT_SEARCH_LENGTH.MAX
    ) {
      usersNotAlreadyPresent.pop();
      newStorageitem = [user, ...usersNotAlreadyPresent];
    }
  }
  setItemBySession(
    BOOKING_FOR,
    newStorageitem,
    { isPiiData: true, shouldStringifyJson: true },
    itemType.ES
  );
};

export const getMyBizTraveller = (requisitionId?: string, railInfo?: any) => (dispatch: any, getState: any) => {
  const mealOptions = railInfo?.availabilityBookingConfig?.applicableFoodTypes 
    ? getApplicableFoodTypes(railInfo?.availabilityBookingConfig?.applicableFoodTypes)
    : [];
  const defaultMealPref = mealOptions[0] || { text: DEFAULT_FOOD_TYPE.value };
  
  if(requisitionId) {
    let myBizTravelers = getItemBySession(
      MY_BIZ_TRAVELERS,
      { isPiiData: true, shouldParseJson: true },
      itemType.ES
    );
    const myBizTravelersList = myBizTravelers?.map(traveler => {
      return {
        name: traveler.name,
        email: traveler.email,
        age: traveler.age ?? AGE_DEFAULT,
        active: true,
        mobile: traveler.phoneNumber,
        gender: getGenderByCode(traveler.gender) || GENDER_DEFAULT,
        nationality: COUNTRY_PREFERENCE_DEFAULT,
        berthPref: BERTH_PREFERENCE_DEFAULT,
        mealPref: defaultMealPref,
        srCitConcession: SENIOR_CITIZEN_CONCESSION_DEFAULT,
        reservationType: RESERVATION_TYPE_DEFAULT
      };
    });

    let primaryTravellerId = myBizTravelers?.findIndex((traveler ) => traveler.isPrimaryPax || traveler.primaryPax);
    const primaryTraveler = myBizTravelers[primaryTravellerId];
    dispatch({
      type: FETCH_TRAVELLERS,
      payload: {
        travellers: myBizTravelersList,
        name: primaryTraveler?.name,
        email: primaryTraveler?.email
      }
    });
    dispatch({
      type: UPDATE_USER_DETAIL,
      payload: {
        primaryPax: {
          primaryTravellerId: primaryTravellerId.toString(),
          primaryPaxEmail: primaryTraveler?.email
        }
      }
    });
    return;
  }

  const { name = "", email = "", mobile = "", gender = "" } =
    getBookingForDataFromStorage()?.[0] || {};
  const travellerList = getState()?.traveller?.travellers || {};
  if (Object.keys(travellerList).length > 0) {
    const updatedTravellers: any = {};
    Object.keys(travellerList).forEach((key) => {
      const traveller = travellerList[key];
      if (traveller.mealPrefEdited) {
        const isPrefAvailable = mealOptions.some(
          option => option.id === traveller.mealPref?.id
        );
        updatedTravellers[key] = {
          ...traveller,
          mealPref: isPrefAvailable ? traveller.mealPref : defaultMealPref,
          mealPrefEdited: isPrefAvailable ? true : false
        };
      } else {
        updatedTravellers[key] = {
          ...traveller,
          mealPref: defaultMealPref
        };
      }
    });
    
    dispatch({
      type: FETCH_TRAVELLERS,
      payload: {
        travellers: updatedTravellers
      }
    });
    return;
  }
  const traveller = [
    {
      name: name,
      email: email,
      age: AGE_DEFAULT,
      active: true,
      mobile: mobile,
      gender: getGenderByCode(gender) || GENDER_DEFAULT,
      nationality: COUNTRY_PREFERENCE_DEFAULT,
      berthPref: BERTH_PREFERENCE_DEFAULT,
      mealPref: defaultMealPref,
      srCitConcession: SENIOR_CITIZEN_CONCESSION_DEFAULT,
      reservationType: RESERVATION_TYPE_DEFAULT
    }
  ];
  if (name && email) {
    dispatch({
      type: FETCH_TRAVELLERS,
      payload: {
        travellers: traveller,
        name: name,
        email: email
      }
    });
    dispatch({
      type: UPDATE_USER_DETAIL,
      payload: {
        primaryPax: {
          primaryTravellerId: "0",
          primaryPaxEmail: email
        }
      }
    });
  }
};
